import mutations from './patientOperations.mutations'
import actions from './patientOperations.actions'
import getters from './patientOperations.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
